// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-group label.light-text {\n    margin-bottom: 5px;\n    color: #d1d1d1;\n    font-size: 12px;\n}\n.form-control.rounded-field {\n    background: #f3f4f5;\n    border: none;\n    font-weight: bold;\n    border-radius: 25px;\n    padding-right: 28px;\n}\nlabel.required::after {\n    color: red;\n    content: \" *\";\n}\n", ""]);
// Exports
module.exports = exports;
